import React, { Component, createRef, Fragment } from "react";
import { connect } from "react-redux";
import * as queryString from "query-string";
import { isEmpty } from "lodash";
import { bindActionCreators } from "redux";
import { fromJS } from "immutable";
import { ActionCreator } from "actions";
import "containers/ShowMore/FreeRounds/styles.scss";
import { CommonModalHeader } from "component/common";
import { FreeRoundsListTypeItem } from "component/listItem";

const SEE_ALL_MODAL = "SEE_ALL_MODAL";
class ShowMoreFreeRounds extends Component {
  constructor(props) {
    super(props);
    this.seeMoreRef = createRef();
    this.onSeeAllScrollHandler = this._onSeeAllScrollHandler.bind(this);
    this.onShowMoreHandler = this._onShowMoreHandler.bind(this);
    this.onClickPrevious = this._onClickPrevious.bind(this);
    this.onCloseClickHandler = this._onCloseClickHandler.bind(this);
    this.onShowTournamentDetailsHandler = this._onShowTournamentDetailsHandler.bind(
      this
    );
    this.onShowTournamentResultHandler = this._onShowTournamentResultHandler.bind(
      this
    );
    this.state = {
      skeleton: [1, 2, 3, 4, 5, 6],
      showCategoryLabel: false,
    };
  }

  _onClickPrevious() {
    this.props.goBack(
      `${this.props.location.pathname}${this.props.location.search}`
    );
    this.props.history.goBack();
  }

  _onCloseClickHandler() {
    this.props.navigateTo(this.props.location.pathname);
  }

  _onShowTournamentDetailsHandler(rel, links, images, providers, winnerView) {
    let params = {
      showJackpotDetails: rel,
      routes: btoa(encodeURIComponent(JSON.stringify(links.toJSON()))),
      isWinnerView: winnerView,
    };

    if (images) {
      params.images = btoa(encodeURIComponent(JSON.stringify(images.toJSON())));
    }

    if (providers) {
      params.providers = btoa(
        encodeURIComponent(JSON.stringify(providers.toJSON()))
      );
    }

    let newLoc = `${this.props.location.pathname}?${queryString.stringify(
      params
    )}`;
    this.props.navigateTo(newLoc);
  }

  _onShowTournamentResultHandler(rel, route, images, providers) {
    let params = {
      showTournamentResults: rel,
      route: btoa(encodeURIComponent(JSON.stringify(route.toJSON()))),
    };

    if (images) {
      params.images = btoa(encodeURIComponent(JSON.stringify(images.toJSON())));
    }

    if (providers) {
      params.providers = btoa(
        encodeURIComponent(JSON.stringify(providers.toJSON()))
      );
    }

    let newLoc = `${this.props.location.pathname}?${queryString.stringify(
      params
    )}`;
    this.props.navigateTo(newLoc);
  }

  _onShowMoreHandler(
    rel,
    route,
    images,
    status,
    subtitle,
    highestJpPoolAmount
  ) {
    let params = {
      showMore: rel,
      route: btoa(encodeURIComponent(JSON.stringify(route.toJSON()))),
      status: status,
      JpSubtitle: subtitle,
      JpAmount: highestJpPoolAmount,
    };

    if (images) {
      params.images = JSON.stringify(images.toJSON());
    }

    let newLoc = `${this.props.location.pathname}?${queryString.stringify(
      params
    )}`;
    this.props.navigateTo(newLoc);
  }

  _onSeeAllScrollHandler(event) {
    const scrollDemo = document.querySelector(".show-more-free-rounds-modal");
    if (scrollDemo.scrollTop !== 0) {
      this.setState({ showCategoryLabel: true });
    } else {
      this.setState({ showCategoryLabel: false });
    }

    if (!this.props.games) return;
    let { page } = this.props.games.toJSON();

    if (
      this.props.games &&
      this.props.games.get("totalPages") === this.props.games.get("page")
    ) {
      return;
    }

    let positionToload =
      event.target.scrollHeight - event.target.offsetHeight * 2;
    let scrollTop = event.target.scrollTop;

    if (
      scrollTop > positionToload &&
      !this.props.isLoading &&
      !this.state.isLoadingNext
    ) {
      let nextPage = page + 1;
      let params = {
        size: 25,
        page: nextPage,
      };
      this.setState({
        isLoadingNext: true,
      });
      this.props.fetchGames(this.props.route, params).then(() => {
        this.setState({
          isLoadingNext: false,
        });
      });
    }
  }

  componentDidMount() {
    if (!this.props.route || !this.props.showMoreRel) return;
    this.props.fetchGames(this.props.route).then(() => {
      this.setState({
        isLoadingNext: false,
      });
    });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.showMoreRel !== this.props.showMoreRel) {
      if (!nextProps.showMoreRel) {
        this.props.hideModal(SEE_ALL_MODAL);
      } else {
        this.props.showModal(SEE_ALL_MODAL);
      }
    }
  }

  resize2fit(elements) {
    elements.forEach((el) => {
      if (!el.parentElement) return;

      el.style.setProperty("--font-size", "1.5em");
      const {
        width: max_width,
        height: max_height,
      } = el.getBoundingClientRect();
      const { width, height } = el.children[0].getBoundingClientRect();
      el.style.setProperty(
        "--font-size",
        Math.min(max_width / width, max_height / height) + "em"
      );
    });

    window.requestAnimationFrame(() => {
      this.resize2fit(document.querySelectorAll(".prize-container"));
    });
  }

  renderSeeAllListItem(item, key) {
    let ListItem = FreeRoundsListTypeItem;
    let detailsLink;
    let continueLink;

    try {
      detailsLink = item
        .get("links")
        .find((link) => link.get("rel") === "rewards.details");
    } catch (err) {}

    try {
      continueLink = item
        .get("links")
        .find((link) => link.get("rel") === "launch.real");
    } catch (err) {}

    return (
      <div
        className={
          this.props.template
            ? `col template-${this.props.template.get("size")}`
            : "col"
        }
        key={key}
      >
        <ListItem
          game={item}
          fetchGameTypes={this.props.fetchGameTypes}
          onClick={() => {
            if (detailsLink)
              this.props.openFreeRoundDetails(
                detailsLink,
                this.props.navigateTo
              );
          }}
          currency={this.props.currency}
          symbol={this.props.symbol}
          continuePlaying={() => {
            let gameId = item.getIn(["claimedGame", "id"]);
            let rel = continueLink.get("rel");
            this.props.gameClick(gameId, rel).then((response) => {
              if (response.location) {
                this.props.navigateTo(response.location);
              } else if (response.params) {
                this.props.setGameAction(response.params);
              }
            });
          }}
        />
      </div>
    );
  }

  render() {
    if (!this.props.showMoreRel) return null;

    this.resize2fit(document.querySelectorAll(".prize-container"));

    return (
      <Fragment>
        <div
          ref={this.seeMoreRef}
          className="show-more-free-rounds-modal"
          onScroll={this.onSeeAllScrollHandler}
        >
          {this.props.route && (
            <CommonModalHeader
              title={this.props.route ? this.props.route.get("name") : ""}
              showTitle={this.state.showCategoryLabel}
              onClickPrevious={this.onClickPrevious}
              onCloseClickHandler={this.onCloseClickHandler}
            />
          )}
          <div className="content">
            {this.props.route && (
              <span className={`label`}>{this.props.route.get("name")}</span>
            )}

            <div
              className="row nopadding"
              style={{
                maxHeight: `${this.props.height}px`,
              }}
            >
              {this.props.games &&
                this.props.games.getIn(["items"]).map((game, key) => {
                  return this.renderSeeAllListItem(game, key);
                })}
              {(this.props.isLoading || this.state.isLoadingNext) && (
                <Fragment>
                  {this.state.skeleton.map((key2) => {
                    return (
                      <FreeRoundsListTypeItem
                        key={key2}
                        className={
                          this.props.template
                            ? `	col template-${this.props.template.get("size")}`
                            : ""
                        }
                        currency={this.props.currency}
                        imageFormat={this.props.imageFormat}
                      />
                    );
                  })}
                </Fragment>
              )}
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  let qs = queryString.parse(window.location.search);
  let { showMore, route } = qs;
  let links;
  let qsroute;
  let games;
  let tournamentPreview;
  let detailsAvailable = false;
  let isLoading = true;
  let template;
  let currency = null;
  try {
    qsroute = fromJS(JSON.parse(decodeURIComponent(atob(route))));
  } catch (err) {}
  try {
    games = state.games.getIn([showMore, "data"]);
  } catch (err) {}
  try {
    isLoading = state.games.getIn([showMore, "isLoading"]);
  } catch (err) {}
  try {
    tournamentPreview = state.tournaments.getIn([showMore]);
  } catch (err) {}
  try {
    detailsAvailable = state.games.getIn([qsroute.get("rel"), "route", "links"])
      ? true
      : false;
  } catch (err) {}
  try {
    template = qsroute.getIn(["templates"]).find((template) => {
      return template.get("id") === "myQT";
    });
  } catch (err) {}
  try {
    links = state.pages
      .getIn(["wl-pages", 0, "content"])
      .find((contentItem) => {
        return contentItem.get("rel") === "tournament.games";
      })
      .get("links")
      .find((link) => {
        return link.get("rel") === showMore;
      })
      .get("links");
  } catch (err) {}
  if (!isEmpty(state.links.get("currency"))) {
    currency = state.links.get("currency");
  }

  return {
    qs,
    route: qsroute,
    currency,
    detailsAvailable,
    showMoreRel: showMore,
    links,
    template,
    games,
    tournamentPreview,
    isLoading,
    isMobile: state.window.get("isMobile"),
    isMultiGame: state.links.get("isMultiGame"),
    imageFormat: state.window.get("imageFormat"),
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return bindActionCreators(ActionCreator, dispatch);
};

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  return Object.assign({}, stateProps, ownProps, {
    fetchGames: (route, params) => dispatchProps.fetchGames(route, params),
    navigateTo: (path) => ownProps.history.push(path),
    showModal: (modal) => dispatchProps.showModal(modal),
    hideModal: (modal) => dispatchProps.hideModal(modal),
    goBack: (url) => dispatchProps.goBack(url),
    fetchGameTypes: (route) => dispatchProps.fetchGameTypes(route),
    openFreeRoundDetails: (route, navigateTo) =>
      dispatchProps.openFreeRoundDetails(route, navigateTo),
    gameClick: (gameId, playType, nav) =>
      dispatchProps.gameClick(gameId, playType, nav),
    setGameAction: (params) => dispatchProps.setGameAction(params),
  });
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(ShowMoreFreeRounds);
